import { render, staticRenderFns } from "./ProductUrl.vue?vue&type=template&id=80026abc&scoped=true&"
import script from "./ProductUrl.vue?vue&type=script&lang=js&"
export * from "./ProductUrl.vue?vue&type=script&lang=js&"
import style0 from "./ProductUrl.vue?vue&type=style&index=0&id=80026abc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80026abc",
  null
  
)

export default component.exports